var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isOn)?_c('img',{attrs:{"height":"30","src":_vm.getImgOn()}}):_c('img',{attrs:{"height":"30","src":_vm.getImgOff()}})])}
var staticRenderFns = []

export { render, staticRenderFns }